








import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin, inAppAlertLogin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';
import { Toast } from 'vant';
import { RadioGroup, Radio } from 'vant';

Vue.use(Radio).use(RadioGroup);

const baseUrl = 'gddt';
@Component({
  components: {
    RadioGroup,
    Radio,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '中心城区公共交通出行便捷性问卷调查',
      url: location.href,
      subtitle: `中心城区公共交通出行便捷性问卷调查`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '中心城区公共交通出行便捷性问卷调查',
        subtitle: `中心城区公共交通出行便捷性问卷调查`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    const unionid = window.localStorage.getItem('unionid');
    const token = window.gettoken();
    if (!unionid && isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    } else if (window.udid && (token === 'null' || !token)) {
      inAppAlertLogin();
    } else if (!window.udid && !isWeiXin()) {
      return Toast.fail('请微信或者上游新闻APP中打开');
    }
  }
}
